// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table_kUG5n {
  height: 100% !important;
  font-size: 7.5px !important;
}

.tableFull_M_yDq {
  font-size: 10px !important;
}

.table_kUG5n [role='rowgroup'] {
  display: flex;
  flex-flow: column nowrap;
  height: calc(100% - (265px)) !important;
}

.table_kUG5n [role='columnheader'] {
  width: 38px !important;
  min-width: 38px !important;
  flex: 1 0 auto !important;
  padding: 0 !important;
  justify-content: center;
  min-height: 145px;
  border-color: var(--color-base300) !important;
}
.table_kUG5n [role='columnheader']:first-child {
  width: 110px !important;
  max-width: 110px !important;
  padding: 8px 10px 8px 10px !important;
  justify-content: start;
}

.table_kUG5n [role='cell'] {
  width: 38px !important;
  min-width: 38px !important;
  flex: 1 0 auto !important;
  justify-content: center;
  padding: 0 !important;
  border-color: var(--color-base300) !important;
}
.table_kUG5n [role='cell']:first-child {
  width: 110px !important;
  max-width: 110px !important;
  justify-content: start;
  padding: 8px 10px 8px 10px !important;
  min-height: 40px !important;
}

.table_kUG5n [role='cell']:last-child {
  border-color: var(--color-base300) !important;
}

.table_kUG5n [role='row'] {
  min-width: max-content !important;
}

.table_kUG5n [role='row']:first-child {
  background-color: var(--color-base050) !important;
}

.table_kUG5n [role="row"]:nth-child(2) {
  background-color: #E2E6EA !important;
}

.table_kUG5n [role='row']:last-child [role='cell'] {
  /* border-bottom: 0px; */
}

.table_kUG5n > div:first-child > [role='row'] {
  min-height: 94.45px !important;
}
.table_kUG5n > [role='rowgroup'] > [role='row']:nth-child(1),
.table_kUG5n > [role='rowgroup'] > [role='row']:nth-child(2) {
  max-height: 60px !important;
}
.table_kUG5n > [role='rowgroup'] > [role='row']:last-child {
  min-height: 82px !important;
}

.row_ctlHT {
  width: 100%;
  height: 100%;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/plugins/dataViewers/cycleTimeMonitoring/components/BondedTable.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,uCAAuC;AACzC;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,iBAAiB;EACjB,6CAA6C;AAC/C;AACA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,yBAAyB;EACzB,uBAAuB;EACvB,qBAAqB;EACrB,6CAA6C;AAC/C;AACA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,sBAAsB;EACtB,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;AACA;;EAEE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":[".table {\n  height: 100% !important;\n  font-size: 7.5px !important;\n}\n\n.tableFull {\n  font-size: 10px !important;\n}\n\n.table [role='rowgroup'] {\n  display: flex;\n  flex-flow: column nowrap;\n  height: calc(100% - (265px)) !important;\n}\n\n.table [role='columnheader'] {\n  width: 38px !important;\n  min-width: 38px !important;\n  flex: 1 0 auto !important;\n  padding: 0 !important;\n  justify-content: center;\n  min-height: 145px;\n  border-color: var(--color-base300) !important;\n}\n.table [role='columnheader']:first-child {\n  width: 110px !important;\n  max-width: 110px !important;\n  padding: 8px 10px 8px 10px !important;\n  justify-content: start;\n}\n\n.table [role='cell'] {\n  width: 38px !important;\n  min-width: 38px !important;\n  flex: 1 0 auto !important;\n  justify-content: center;\n  padding: 0 !important;\n  border-color: var(--color-base300) !important;\n}\n.table [role='cell']:first-child {\n  width: 110px !important;\n  max-width: 110px !important;\n  justify-content: start;\n  padding: 8px 10px 8px 10px !important;\n  min-height: 40px !important;\n}\n\n.table [role='cell']:last-child {\n  border-color: var(--color-base300) !important;\n}\n\n.table [role='row'] {\n  min-width: max-content !important;\n}\n\n.table [role='row']:first-child {\n  background-color: var(--color-base050) !important;\n}\n\n.table [role=\"row\"]:nth-child(2) {\n  background-color: #E2E6EA !important;\n}\n\n.table [role='row']:last-child [role='cell'] {\n  /* border-bottom: 0px; */\n}\n\n.table > div:first-child > [role='row'] {\n  min-height: 94.45px !important;\n}\n.table > [role='rowgroup'] > [role='row']:nth-child(1),\n.table > [role='rowgroup'] > [role='row']:nth-child(2) {\n  max-height: 60px !important;\n}\n.table > [role='rowgroup'] > [role='row']:last-child {\n  min-height: 82px !important;\n}\n\n.row {\n  width: 100%;\n  height: 100%;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `table_kUG5n`,
	"tableFull": `tableFull_M_yDq`,
	"row": `row_ctlHT`
};
export default ___CSS_LOADER_EXPORT___;
